import React from 'react';
import FieldSingleLine from 'client/components/FormContent/Field/FieldSingleLine';
import FieldMultiLine from 'client/components/FormContent/Field/FieldMultiLine';
import FieldTextChoice from 'client/components/FormContent/Field/FieldTextChoice';
import FieldImageChoice from 'client/components/FormContent/Field/FieldImageChoice';
import FieldSingleDropOption from 'client/components/FormContent/Field/FieldSingleDropOption';
import FieldDoubleDropdownList from 'client/components/FormContent/Field/FieldDoubleDropdownList';
import FieldTerm from 'client/components/FormContent/Field/FieldTerm';
import FieldFileUpload from 'client/components/FormContent/Field/FieldFileUpload';
import FieldRating from 'client/components/FormContent/Field/FieldRating';
import TextBox from 'client/components/Sections/Textbox/Textbox';
import FieldDatePicker from 'client/components/FormContent/Field/FieldDatePicker';

/**
 * 依照類型建立 field 欄位
 *
 * - 101: 姓名
 * - 102: 電子信箱
 * - 103: 手機號碼
 * - 104: 其他加密個資
 * - 201: 單行文字
 * - 202: 多行文字
 * - 203: 網址
 * - 301: 文字選擇題
 * - 302: 圖片選擇題
 * - 303: 單層下拉式選單
 * - 304: 雙層下拉式選單
 * - 311: 等級評分
 * - 401: 日期 (僅年月日)
 * - 501: 視覺介面 (純文字區塊、按鈕)
 * - 502: Froala 編輯器 (Text Box)
 * - 600: 同意條款
 * - 602: 檔案上傳
 */
const createField = data => {
    const { type } = data;

    return {
        101: <FieldSingleLine {...data} />,
        102: <FieldSingleLine {...data} />,
        103: <FieldSingleLine {...data} />,
        104: <FieldSingleLine {...data} />,
        201: <FieldSingleLine {...data} />,
        202: <FieldMultiLine {...data} />,
        203: <FieldSingleLine {...data} />,
        301: <FieldTextChoice {...data} />,
        302: <FieldImageChoice {...data} />,
        303: <FieldSingleDropOption {...data} />,
        304: <FieldDoubleDropdownList {...data} />,
        311: <FieldRating {...data} />,
        401: <FieldDatePicker {...data} />,
        502: <TextBox {...data} style={`padding: 0 32px;box-sizing: border-box;`} />,
        600: <FieldTerm {...data} />,
        602: <FieldFileUpload {...data} />
    }[type];
};

export default createField;
